import * as core from 'cw-ui-core';
import { call, put } from 'redux-saga/effects';
import { GET, POST, DELETE, PATCH, getHeaders, autoHideMessages } from 'src/services/ApiService';
import { EDIT_IMPORTED_USER_DIALOG } from 'src/features/users/components/ImportedUsers/EditImportedUserDialog/EditImportedUserDialog';
import { APPROVE_IMPORTED_USER_DIALOG } from 'src/features/users/components/ImportedUsers/ApproveImportedUserDialog/ApproveImportedUserDialog';
import Locale from 'src/i18n';
import { SoftwareCatalog, getInstanceName, loadClients } from 'src/services/ProductsService';
import IMPORTED_USERS from 'src/features/users/components/ImportedUsers/Constants';
import { loadUsersWithConnectedApps } from 'src/services/UsersService';
import { toArray } from '../util/Util';

const filterUsersList = (list, value) => {
    let filteredUsersList = [];
    if (value === 'emailTaken') {
        filteredUsersList = list.filter(u => u.emailTaken);
    } else if (value === 'existingUser') {
        filteredUsersList = list.filter(u => u.updatesUser);
    } else if (value === 'newUser') {
        filteredUsersList = list.filter(u => !u.emailTaken && !u.updatesUser);
    } else {
        filteredUsersList = list;
    }
    return filteredUsersList;
};
const searchUsersList = (list, value) => {
    return list.filter(
        u =>
            u.userName.toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) > -1 ||
            u.email.toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) > -1
    );
};

export function* getUsersList() {
    const searchText = yield core.getScreenData(core.Store().getState().screen, ['importedUsersSearchText']);
    const filterText = yield core.getScreenData(core.Store().getState().screen, ['importedUsersFilterText']);
    const importedUsers = toArray(yield core.getScreenData(core.Store().getState().screen, ['importedUsers']));
    const searchedUsersList = searchText ? searchUsersList(importedUsers, searchText) : importedUsers;
    const refinedusersList = filterText ? filterUsersList(searchedUsersList, filterText) : searchedUsersList;

    yield core.Store().dispatch(core.setScreenData(['refinedUsersList'], refinedusersList));
}

export function* loadImportedUsers() {
    const result = yield call(GET, '/users/imported', getHeaders());
    if (result.isSuccess) {
        const importedUsers = result.response.map(user => {
            const importedUser = user;
            importedUser.product = SoftwareCatalog[importedUser.softwareId];
            importedUser.instance = getInstanceName(importedUser.redirectUris[0], importedUser.softwareId);
            return importedUser;
        });
        yield put(core.setScreenData(['importedUsers'], importedUsers));
        yield put(core.setScreenData(['importedUsersCount'], importedUsers.length));
        yield call(getUsersList);
    } else {
        const error = core.formatMessage(Locale.failedGetUsers);
        yield put(core.setErrorScreenMessage(error, false, result.errorMessages));
        yield call(autoHideMessages);
    }
}

export function* loadImportedUsersCount() {
    const result = yield call(GET, '/users/imported', getHeaders());
    if (result.isSuccess) {
        yield put(core.setScreenData(['importedUsersCount'], result.response.length));
    } else {
        const error = core.formatMessage(Locale.failedGetUsers);
        yield put(core.setErrorScreenMessage(error, false, result.errorMessages));
        yield call(autoHideMessages);
    }
}

export function* getImportedUser(id, screenKey = core.ACTIVE_SCREEN_KEY) {
    const result = yield call(GET, `/users/imported/${id}`, getHeaders());
    if (result.isSuccess) {
        yield put(core.setScreenData(['userDetails'], result.response, screenKey));
    } else {
        const error = core.formatMessage(Locale.failedGetUser);
        yield put(core.setErrorScreenMessage(error, false, result.errorMessages, screenKey));
        yield call(autoHideMessages, screenKey);
    }
}

export function* editImportedUser(id, updates) {
    const result = yield call(PATCH, `/users/imported/${id}`, getHeaders(), updates);
    if (result.isSuccess) {
        yield call(loadImportedUsers);
        yield put(core.hideDialog(EDIT_IMPORTED_USER_DIALOG));
    } else {
        const error = core.formatMessage(Locale.failedUpdateUser);
        yield put(core.setErrorScreenMessage(error, false, result.errorMessages, EDIT_IMPORTED_USER_DIALOG));
        yield call(autoHideMessages, EDIT_IMPORTED_USER_DIALOG);
    }
}

export function* deleteImportedUser(id) {
    const result = yield call(DELETE, `/users/imported/${id}`, getHeaders());
    if (result.isSuccess) {
        yield put(
            core.setSuccessfulScreenMessage(core.formatMessage(Locale.rejectionConfirmation), false, [], IMPORTED_USERS)
        );
        yield call(loadImportedUsers);
        yield call(autoHideMessages, IMPORTED_USERS);
        yield call(loadClients);
    } else {
        const error = core.formatMessage(Locale.failedDeleteUser);
        yield put(core.setErrorScreenMessage(error, false, result.errorMessages, IMPORTED_USERS));
        yield call(autoHideMessages, IMPORTED_USERS);
    }
}

export function* inviteImportedUser(selectedIds, loginScheme) {
    if (selectedIds.length === 0) {
        yield put(core.setErrorScreenMessage(core.formatMessage(Locale.deniedInvitation), false, []));
        yield call(autoHideMessages);
    } else {
        const loginMethod = loginScheme ? `?loginScheme=${loginScheme}` : '';
        const endpoint = `/users/invite${loginMethod}`;
        const result = yield call(POST, endpoint, getHeaders(), selectedIds);

        if (!result.isSuccess) {
            const error = core.formatMessage(Locale.failedInviteImportedUser);
            yield put(core.setErrorScreenMessage(error, false, result.errorMessages, APPROVE_IMPORTED_USER_DIALOG));
            yield call(autoHideMessages, APPROVE_IMPORTED_USER_DIALOG);
            return;
        }

        yield put(core.hideDialog(APPROVE_IMPORTED_USER_DIALOG));
        yield put(
            core.setSuccessfulScreenMessage(core.formatMessage(Locale.invitationSent), false, [], IMPORTED_USERS)
        );
        yield call(loadImportedUsers);
        yield call(autoHideMessages, IMPORTED_USERS);
        yield call(loadClients);
        yield call(loadUsersWithConnectedApps);
    }
}

export function* getMatchedContactList(screenKey = core.ACTIVE_SCREEN_KEY) {
    const matchedContacts = [
        {
            userName: 'IsaiahAlvarado12!',
            email: 'joanie_jacobs@keshaun.com',
            product: 'Manage',
            instance: 'managestaging.connectwisedev.com',
            firstName: 'Isaiah',
            lastName: 'Alvarado',
            matchedContacts: [
                {
                    userName: 'Marguerite McBride',
                    email: 'margueritemcBride@gmail.com',
                    prefferedNumber: '813-756-9872',
                    prefferedExtension: '9931',
                    fax: '813-234-9874',
                    mobile: '813-234-9874',
                },
                {
                    userName: 'Miguel McBride',
                    email: 'miguelmcBride@gmail.com',
                    prefferedNumber: '813-756-9872',
                    prefferedExtension: '9931',
                    fax: '813-234-9874',
                    mobile: '813-234-9874',
                },
            ],
        },
        {
            userName: 'Jason_Burton',
            email: 'jason_burton@keshaun.com',
            product: 'Manage',
            instance: 'managestaging.connectwisedev.com',
            firstName: 'Jason',
            lastName: 'Burton',
            matchedContacts: [
                {
                    userName: 'Jason Burton',
                    email: 'jasonbuton@gmail.com',
                    prefferedNumber: '813-756-9872',
                    prefferedExtension: '9931',
                    fax: '813-234-9874',
                    mobile: '813-234-9874',
                },
                {
                    userName: 'Josua Burton',
                    email: 'josuaburton@gmail.com',
                    prefferedNumber: '813-756-9872',
                    prefferedExtension: '9931',
                    fax: '813-234-9874',
                    mobile: '813-234-9874',
                },
            ],
        },
    ];

    matchedContacts.forEach(contact => {
        core.Store().dispatch(core.setScreenData([contact.email, 'firstName'], contact.firstName, screenKey));
        core.Store().dispatch(core.setScreenData([contact.email, 'lastName'], contact.lastName, screenKey));
    });

    yield core.Store().dispatch(core.setScreenData(['matchedContactList'], matchedContacts, screenKey));
}

export function* getContactListForMappedToCrm() {
    yield core.Store().runSaga(getMatchedContactList, IMPORTED_USERS);
    const matchedContactList = toArray(
        core.getScreenData(core.Store().getState().screen, ['matchedContactList'], IMPORTED_USERS)
    );
    const defaultOptions = {};
    matchedContactList.forEach(contact => {
        defaultOptions[contact.email] = contact.matchedContacts[0].userName;
    });
    core.Store().dispatch(core.setScreenData(['matchedContactOption'], defaultOptions, IMPORTED_USERS));
    core.Store().dispatch(core.setScreenData(['showMatchedContactsList'], true, IMPORTED_USERS));
    if (matchedContactList.length > 0) {
        core.Store().dispatch(core.setScreenData(['showMatchingCrmContacts '], true, IMPORTED_USERS));
    }
}

export function* countContactsMappedToCrm() {
    yield core.Store().runSaga(getMatchedContactList, IMPORTED_USERS);
    const matchedContactList = toArray(
        core.getScreenData(core.Store().getState().screen, ['matchedContactList'], IMPORTED_USERS)
    );
    yield put(core.setScreenData(['contactsMappedToCrmCount'], matchedContactList.length));
}
